var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"id":_vm.id,"aria-controls":_vm.tab,"role":"tab","type":"button"},on:{"click":function($event){return _vm.changeTab(_vm.tab)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }